import { createContext, useContext } from "react";
const TabsContext = createContext({
  variant: "clean",
  shape: "pill"
});
function useTabsContext() {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("Child components of Tabs cannot be rendered outside the Tabs component!");
  }
  return context;
}
export {
  TabsContext,
  useTabsContext
};
//# sourceMappingURL=context8.js.map
